

























import Vue from 'vue'
import {Component, Inject} from 'vue-property-decorator'
import {Observer} from 'mobx-vue'

import {UtilityBar} from '../../stores/UtilityBar'
import {RootStore} from '../../stores/RootStore'

import Popper from './Popper.vue'
import UtilItem from './UtilityBarItem.vue'

@Observer
@Component({components: {
    Popper,
    UtilItem
}})
export default class UtilBar extends Vue {
    @Inject()
    private readonly rootStore!: RootStore

    utilityBar!: UtilityBar

    open = false

    created() {
        this.utilityBar = this.rootStore.utilityBar
    }

    mounted() {
    }

    handleClick() {
        this.open = !this.open
    }
}
